import { Step } from "../../../types/Step";
import { View } from "../../../types/Views";
import TelemetryClient from "../../../Telemetry/compositions/TelemetryClient";
import IUserEvent, { UserEventType } from "../../types/IUserEvent";
import { GoogleTagsManagerEventFactory } from "../Components/Heatmapping/GoogleTagsManagerEventFactory";
import GoogleTagsUserEventConsumer from "../Components/Heatmapping/GoogleTagsUserEventConsumer";
import IUserEventConsumerProps from "../types/IUserEventConsumerProps";
import HeatmappingClient from "./HeatmappingClient";

const eventFactory = new GoogleTagsManagerEventFactory();
export const approvedGtmSteps: Step[] = [
  Step.qualify,
  Step.medicalGeneral,
  Step.medicalPacemaker,
  Step.medicalRadiation,
  Step.medicalDiabetic,
  Step.medicalAll,
  Step.centerSelection,
  Step.scheduling
];
export const approvedGtmViews: View[] = [
  View.thankYou,
  View.nonCandidate,
  View.noAvailability,
  View.endedSession,
  View.expiredReservation
];

// TODO - this needs improvement, but will suffice for type safety temporarily.
const isUserEvent = <T>(event: unknown): event is IUserEvent<T> =>
  typeof event === "object" && event !== null && "type" in event && "value" in event;

export const eventRules: Partial<Record<UserEventType, (event: unknown) => boolean>> = {
  [UserEventType.StepArrival]: event => isUserEvent<Step>(event) && approvedGtmSteps.some(step => step === event.value),
  [UserEventType.ViewArrival]: event => isUserEvent<View>(event) && approvedGtmViews.some(view => view === event.value)
};

const ComposedGoogleTagsUserEventConsumer: React.FC<IUserEventConsumerProps> = props =>
  GoogleTagsUserEventConsumer({
    ...props,
    heatmappingClient: HeatmappingClient,
    rules: eventRules,
    eventFactory,
    telemetryClient: TelemetryClient
  });

export default ComposedGoogleTagsUserEventConsumer;
